import { useEffect, useState } from "react";
import { SignalRServiceBase } from "./SignalRTypes";
import $ from "jquery";
import { esd_storage } from "../Domain";
window.jQuery = $;
require('signalr');

type SignalRServiceV0Props = {
    url: string;
}


export const useSignalRServiceV0 = (props: SignalRServiceV0Props) => {
    const [connection, setConnection] = useState<SignalR.Hub.Proxy | undefined>(undefined);
    const [connectState, setConnectState] = useState<boolean>(false);
    const [url, setUrl] = useState<string>("");
    const [myConntection, setMyConntection] = useState<SignalR.Hub.Connection | undefined>(undefined);
    const [privateConnection, setPrivateConnection] = useState<SignalR.Hub.Proxy | undefined>(undefined);

    useEffect(() => {
        setUrl(props.url)
    }, [props.url])

    useEffect(() => {
        console.log("useEffect privateConnection:", privateConnection);
        if (privateConnection?.connection.state === 1) {
            setConnection(privateConnection);
            setConnectState(true);

            // 加入群組
            privateConnection.invoke("UserInGroupAsync", esd_storage.getItem("user_id"), "ESD")
        } else {
            setConnection(undefined);
            setConnectState(false);
        }
    }, [privateConnection, privateConnection?.connection.state])

    useEffect(() => {
        if (url) {
            if (window.jQuery) {
                console.log('jQuery version:', window.jQuery.fn.jquery); // 應該顯示 2.2.4
            } else {
                window.jQuery = window.$;
                console.error('jQuery is not loaded');
            }
            init();
        }
    }, [url])

    useEffect(() => {
        if (myConntection) connect();
    }, [myConntection])

    const init = async () => {
        if (localStorage.getItem("defaultApiVersion") === "framework")
            await setConnectionOptions();
    }

    const setConnectionOptions = async () => {
        setMyConntection($.hubConnection(`${url}`));
    }

    const connect = async () => {
        // 啟動連線  
        if (myConntection) {
            myConntection.stateChanged((state) => {
                if (state.newState === $.signalR.connectionState.connected) {
                    console.log('SignalR reconnected ✅');
                } else if (state.newState === $.signalR.connectionState.disconnected) {
                    console.warn('SignalR disconnected ❌');
                    // 這裡可以嘗試重新連接
                    reconnect();
                }
            });
            myConntection.start()
                .done(() => {
                    console.log('SignalR Connected ✅');
                    setPrivateConnection(myConntection!.createHubProxy('broadcastHub'));
                })
                .fail(() => {
                    console.error('SignalR Connection Error ❌');
                    // Optionally handle retry logic here
                    reconnect();
                });
        }

    }

    const reconnect = () => {
        setTimeout(() => {
            connect(); // 嘗試重新連接
        }, 5000); // 每5秒重試一次
    };

    return { connection, connectState };
}